import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { VERBOSITY, API_BASE_URL } from '../constants';

interface DaySlots {
  date: string;
  slots: number[];
}

const formatApiDate = (date: Date) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}T11:12:10`;
};

const formatLocalDateTime = (date: Date) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};

const getNextWorkDayDates = (count: number) => {
  const dates: string[] = [];
  const cursor = new Date();
  cursor.setHours(0, 0, 0, 0);

  while (dates.length < count) {
    cursor.setDate(cursor.getDate() + 1);
    const day = cursor.getDay();
    if (day === 0 || day === 6) continue;
    dates.push(formatApiDate(cursor));
  }

  return dates;
};

const readStoredUserName = () => {
  const fullName = localStorage.getItem('userFullName')?.trim();
  const loginUserName = localStorage.getItem('loginUserName')?.trim();
  return fullName || loginUserName || 'Benutzer';
};

export function ObsoleteBookingPage() {
  const [weekData, setWeekData] = useState<DaySlots[]>([]);
  const [loading, setLoading] = useState(true);
  const [userName] = useState(readStoredUserName);
  const navigate = useNavigate();

  const handleTimeClick = async (date: string, minutes: number) => {
    const appointmentId = localStorage.getItem('selectedAppointmentId');
    const token = localStorage.getItem('token');

    console.log("handleTimeClick: appointmentId=" + appointmentId);
    
    if (!appointmentId || !token) return;
    
    const newDate = new Date(date);
    newDate.setHours(Math.floor(minutes / 60), minutes % 60, 0, 0);

    console.log("handleTimeClick: newDate=" + newDate + " " + formatLocalDateTime(newDate));
    
    try {
      // '/api/appointments/move'
      const apiCall = API_BASE_URL + '/appointments/move';
      await fetch(apiCall, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
          appointmentId,
          when: formatLocalDateTime(newDate),
        }),
      });
      
      navigate('/appointments');
    } catch (err) {
      console.error('Failed to move appointment:', err);
    }
  };

  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString().slice(-2);
    return `${day}.${month}.${year}`;
  };

  const formatTime = (minutes: number) => {
    const hours = Math.floor(minutes / 60).toString().padStart(2, '0');
    const mins = (minutes % 60).toString().padStart(2, '0');
    return `${hours}:${mins}`;
  };

  useEffect(() => {
    const fetchWeekSlots = async () => {
      const token = localStorage.getItem('token');
      const loginPatientIdRaw = localStorage.getItem('loginPatientId');
      let patientId = '';

      try {
        patientId = loginPatientIdRaw ? JSON.parse(loginPatientIdRaw) : '';
      } catch {
        patientId = loginPatientIdRaw?.trim() || '';
      }

      const dates = getNextWorkDayDates(5);
      const results: DaySlots[] = [];

      console.log("/api/appointments/possible patientId=" + patientId);

      for (const date of dates) {
        try {
          const res = await fetch('/api/appointments/possible', {
            method: 'POST',
            headers: { 
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({
              patientId,
              practitionerId: 'data_c_11',
              duration: '60',
              date,
            }),
          });
          const slots = await res.json();

          console.log("Slots=" + JSON.stringify(slots));

          results.push({ date, slots: Array.isArray(slots) ? slots : [] });
        } catch {

          console.log("Slots=None");

          results.push({ date, slots: [] });
        }
      }

      setWeekData(results);
      setLoading(false);
    };

    fetchWeekSlots();
  }, []);

  if (loading) return <div className="text-center p-4">Loading...</div>;

  return (
    <div className="max-w-4xl mx-auto mt-8 p-6 bg-white rounded-lg shadow-md">
      <h1 className="text-2xl font-bold mb-6 text-center">Termin Buchen</h1>
      <p className="mb-6 text-gray-600">Guten Tag {userName}, bitte wählen sie einen Termin:</p>
      
      <div className="space-y-4">
        {weekData.map(({ date, slots }) => (
          <div key={date} className="flex gap-4 border-b pb-4">
            <div className="w-24 font-semibold">{formatDate(date)}</div>
            <div className="flex flex-wrap gap-2 ml-4">
              {slots.map((minutes) => (
                <button
                  key={minutes}
                  onClick={() => handleTimeClick(date, minutes)}
                  className="bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600 font-medium"
                >
                  {formatTime(minutes)}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
